export const SHOW_ALL = 'SHOW_ALL';
export const SHOW_PARENT = 'SHOW_PARENT';
export const SHOW_CHILD = 'SHOW_CHILD';



// WEBPACK FOOTER //
// ./ext/tree-select/src/strategies.js